// 19.1.3.10 Object.is(value1, value2)
var $export = require('./_export');
$export($export.S, 'Object', {is: require('./_same-value')});


//////////////////
// WEBPACK FOOTER
// ../~/react-helmet/~/core-js/modules/es6.object.is.js
// module id = 2805
// module chunks = 3